export default __webpack_public_path__ + "static/media/ICONOS INGLÉS  MI SEGURO SOMIT -06.63b2afb3.png";